import { getMyModulesOnce } from "./myModulesClient";

// system_settings deliberately excluded: it's a grab-bag of reference-data submodules
// (statuses, transitions, waste streams, membership tiers, etc.) that ordinary members
// routinely get read access to, and no role in this system is ever granted system_settings
// at the parent level (only per-submodule) — so including it here only produces false
// positives. account_settings (users/roles/modules) is the reliable admin-surface signal:
// every admin-tier role holds at least one of those, and no non-admin role holds any.
const ADMIN_MODULE_ALIASES = new Set([
  "users",
  "user",
  "roles",
  "role",
  "modules",
  "module",
  "account_settings",
  "account-settings",
]);

const extractModulesPayload = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.modules)) return payload.modules;
  if (Array.isArray(payload?.result)) return payload.result;
  return [];
};

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const moduleMatchesAdminSurface = (moduleItem) => {
  const candidates = [
    moduleItem?.name,
    moduleItem?.resource,
    moduleItem?.label,
    moduleItem?.id,
    moduleItem?.moduleId,
    moduleItem?.route,
  ]
    .map(normalize)
    .filter(Boolean);

  return candidates.some((candidate) => ADMIN_MODULE_ALIASES.has(candidate));
};

const hasAnyScopeAction = (moduleItem, actionPrefix) => {
  const actions = Array.isArray(moduleItem?.actions) ? moduleItem.actions : [];
  return actions.some((action) => {
    const actionName =
      typeof action === "string"
        ? String(action)
        : String(action?.name || "");
    return actionName.toLowerCase() === `${actionPrefix.toLowerCase()}any`;
  });
};

export const resolvePrivilegedAccessFromModules = (modules) => {
  const normalizedModules = Array.isArray(modules) ? modules : [];
  const adminSurfaceModules = normalizedModules.filter(moduleMatchesAdminSurface);

  return adminSurfaceModules.some(
    (moduleItem) =>
      hasAnyScopeAction(moduleItem, "read") ||
      hasAnyScopeAction(moduleItem, "create") ||
      hasAnyScopeAction(moduleItem, "update") ||
      hasAnyScopeAction(moduleItem, "delete")
  );
};

export const fetchAndResolvePrivilegedAccess = async () => {
  try {
    const payload = await getMyModulesOnce();
    const modules = extractModulesPayload(payload);
    return resolvePrivilegedAccessFromModules(modules);
  } catch (error) {
    console.error("Failed to resolve privileged access from modules:", error);
    return false;
  }
};
